import type { MissionStatus } from '../api/types'

/** A mission's state, as a word and a colour rather than a colour alone. */
export function StatusPill({ status }: { status: MissionStatus }) {
  const tone =
    status === 'ACTIVE'
      ? 'success'
      : status === 'PLANNING'
        ? 'info'
        : status === 'COMPLETED'
          ? 'neutral'
          : 'neutral'

  const label =
    status === 'ACTIVE'
      ? 'Running'
      : status === 'PLANNING'
        ? 'Planned'
        : status === 'COMPLETED'
          ? 'Finished'
          : 'Archived'

  return <span className={`pill ${tone}`}>{label}</span>
}
